(ns manage.content-variant-ocp.db.authentication
  (:require [clojure.spec.alpha :as spec]
            [clojure.string :as str]
            [common.form.core :as form]
            [common.loader.db :as loader.db]
            [common.ocp.db]
            [manage.content-variant-ocp.db.core :refer [entity-name ui-messages]]
            [manage.resource.feed-imports :as feed-imports]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]))

(def initial-value
  {:api-key ""
   :api-key-field-name ""
   :api-key-field-type "none"})

(spec/def ::api-key (spec/and string? (complement str/blank?)))
(spec/def ::api-key-field-name (spec/and string? (complement str/blank?)))
(spec/def ::api-key-field-type #{"none" "query-parameter" "header-parameter"})

(spec/def ::value
  (spec/or :none #(= (:api-key-field-type %) "none")
           :some (spec/keys :req-un [::api-key ::api-key-field-name ::api-key-field-type])))

(def validate-form
  (rf/enrich
   (form/get-validate-form-fn :form.content-variant.authentication ::value)))

(rf/reg-event-fx :form.content-variant.authentication/open
  [(rf/inject-cofx :sub :resource.adset/current-feed-id)
   (rf/inject-cofx :sub :resource.feed-importers/one)]
  (fn [{:keys [db]
        :resource.feed-importers/keys [one]} _]
    (let [value (merge initial-value (-> (get one :value)
                                         (select-keys [:api-key-field-type :api-key-field-name])))]
      {:db (assoc-in db [:form.content-variant.authentication] {:value value})
       :fx [[:dispatch [:form.content-variant.authentication/init value]]]})))

(rf/reg-event-fx :form.content-variant.authentication/submit-form
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)
   validate-form]
  (fn [{:keys [db resource.user/token url-context]} [_ payload next-tab]]
    (let [type (get-in db [:table.feed/meta :type])
          feed-id (get-in db [:resource.adset/one :value :feedId])
          payload* (merge
                    (select-keys payload [:api-key :api-key-field-type :api-key-field-name])
                    {:type type
                     :id feed-id})]
      (-> {:db db}
          (mr/update-db assoc-in [:form.content-variant.authentication :api-key-field-type] (:api-key-field-type payload*))
          (common.loader.db/open-loader)
          (feed-imports/http-patch-feed url-context
                                        payload*
                                        token
                                        {:on-success [:form.content-variant.authentication/submit-form-success next-tab]
                                         :on-failure [:form.content-variant.authentication/submit-form-failure]})))))

(rf/reg-event-fx :form.content-variant.authentication/submit-form-success
  (fn [{:keys [db]} [_ next-tab response]]
    (-> {:db db}
        (feed-imports/on-feed-importers-one-success response)
        (mr/update-db assoc-in [:form.content-variant.authentication] {:value response
                                                                       :mode  :edit})
        (loader.db/close-loader)
        (mr/conj-fx [:dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :success
                                 :message (get-in ui-messages [:edit :success])}]])
        (cond-> (nil? (next-tab))
          (mr/conj-fx [:dispatch [:ocp/close]])))))

(rf/reg-event-fx :form.content-variant.authentication/submit-form-failure
  (fn [{:keys [db]} [event response]]
    (-> {:db db}
        (loader.db/close-loader)
        (mr/conj-fx [:dispatch [:response-handler/handle-response
                                {:entity-name entity-name
                                 :type :error
                                 :event event
                                 :message (get-in ui-messages [:edit :failure])
                                 :response response}]]))))

(def use-error-message (partial form/use-error-message :form.content-variant.authentication))

(def use-bind-control (partial form/use-bind-control :form.content-variant.authentication))

(form/register-form {:namespace :form.content-variant.authentication
                     :initial-value initial-value
                     :validate-form validate-form
                     :submit-event :form.content-variant.authentication/submit-form})
